<app-em-loader
  *ngIf="loadingService.isLoading$ | async"
  variant="fullscreen"
  [message]="loadingService.message$ | async"
></app-em-loader>
<router-outlet></router-outlet>